import { Box } from "@mui/material";
import { styled, Theme } from "@mui/material/styles";

export const COLLAPSED_HEIGHT = 48;
export const GAP_SIZE = 8;
export const COLLAPSED_WIDTH = 100;

export const HEIGHTS = {
  BASE: 89,
  XXL: 87,
  XL: 82,
  CUSTOM_1440: 79,
  CUSTOM_1309: 75,
  LG: 72,
  MD: 68,
  SM: 170,
};

const getResponsiveHeights = (theme: Theme) => ({
  // height: `${HEIGHTS.BASE}vh`,
  height: "100%",
  [theme.breakpoints.down("xxl")]: {
    // height: `${HEIGHTS.XXL}vh`,
    height: "100%",
  },
  [theme.breakpoints.down("xl")]: {
    // height: `${HEIGHTS.XL}vh`,
    height: "100%",
  },
  "@media only screen and (max-width: 1440px)": {
    // height: `${HEIGHTS.CUSTOM_1440}vh`,
    height: "100%",
  },
  "@media only screen and (max-width: 1309px)": {
    // height: `${HEIGHTS.CUSTOM_1309}vh`,
    height: "100%",
  },
  [theme.breakpoints.down("lg")]: {
    // height: `${HEIGHTS.LG}vh`,
    height: "100%",
  },
  [theme.breakpoints.down("sm")]: {
    // height: `${HEIGHTS.SM}vh`,
    height: "100%",
    zoom: "45%",
  },
});

export const AccordionRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: GAP_SIZE,
  width: "100%",
  minHeight: 0,
  overflow: "hidden",
  ...getResponsiveHeights(theme),
}));

export const AccordionRowContainer = styled(Box)({
  display: "flex",
  gap: GAP_SIZE,
  width: "100%",
  minHeight: COLLAPSED_HEIGHT,
  transition: "flex 0.3s ease",
});
